import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  userGroupData: {},
  error: "",
  success: false,
  status: "",
};

const fetchUserGroups = createAsyncThunk("fetch/user-groups", async () => {
  const mobile = localStorage.getItem("mobile");
  try {
    const result = await axios.get(
      `https://apac.api.capillarytech.com/mobile/v2/api/userGroup2?externalId=${mobile}`
    );
    return result?.data;
  } catch (err) {
    console.log(err);
  }
});

const userGroupSlice = createSlice({
  name: "user-group",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchUserGroups.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchUserGroups.fulfilled, (state, action) => {
    
      state.loading = false;
      state.userGroupData = action.payload;
      state.success = action.payload?.warnings;
      state.error = action.payload?.warnings;
    });
    builder.addCase(fetchUserGroups.rejected, (state, action) => {
      state.loading = false;
      state.userGroupData = {};
      state.success = false;
      state.error = action.error.message;
    });
  },
});

export default userGroupSlice.reducer;
export { fetchUserGroups };
